import { FunctionComponent } from "react";

import { Fact, TypedId, typedIdsEqual } from "../src/types";

const FactView: FunctionComponent<{
  fact: Fact;
  legacy?: boolean;
  onArgClick?: (arg: TypedId) => void;
  onPredicateClick?: () => void;
  ignoreTypes?: String[];
  typesOnly?: boolean;
  highlightArg?: TypedId;
  compact?: boolean;
}> = ({
  fact,
  legacy,
  onArgClick,
  onPredicateClick,
  ignoreTypes,
  typesOnly,
  highlightArg,
  compact,
}) => {
  function renderObjectLiteral(type: string, id?: string) {
    return legacy ? `${type}:${id ?? "_"}` : `${type}{${id ? `"${id}"` : "_"}}`;
  }
  return (
    <div className="font-mono text-sm">
      <span
        className={`text-gray-800 ${onPredicateClick ? "cursor-pointer" : ""}`}
        onClick={() => onPredicateClick && onPredicateClick()}
      >
        {fact.predicate}
      </span>
      <span className="text-gray-400">{compact ? "(" : " ( "}</span>
      {fact.args.map((arg, i) => (
        <span key={`arg-${i}`}>
          {i > 0 && (
            <span className="text-gray-400">{compact ? "," : " , "}</span>
          )}
          <span
            onClick={
              onArgClick &&
              ((e) => {
                e.stopPropagation();
                onArgClick(arg);
              })
            }
            className={`text-indigo-800 ${onArgClick ? "cursor-pointer" : ""} ${
              highlightArg && typedIdsEqual(highlightArg, arg)
                ? "bg-indigo-200"
                : ""
            }`}
          >
            {ignoreTypes && ignoreTypes.includes(arg.type)
              ? arg.id
              : arg.type === "_" && arg.id === "_"
              ? "_"
              : arg.id === "_"
              ? typesOnly
                ? arg.type
                : renderObjectLiteral(arg.type)
              : arg.type === "String"
              ? i === 2 ||
                // WOWHACK(gj): see `api::types::Query::from<api::Query>` in
                // `api/src/types.rs` for the other side of this " and " hack.
                arg.id.startsWith(" and ")
                ? arg.id.toString()
                : `"${arg.id}"`
              : arg.type === "Boolean"
              ? arg.id.toString()
              : renderObjectLiteral(arg.type, arg.id)}
          </span>
        </span>
      ))}
      <span className="text-gray-400">{compact ? ")" : " )"}</span>
    </div>
  );
};

export default FactView;
